import { ChevronLeftIcon, EnterIcon } from '@radix-ui/react-icons';
import { Button, Card, Flex, Spinner } from '@radix-ui/themes';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import { useMutation } from 'react-query';
import { useNavigate } from 'react-router-dom';
import RadioGroupComponent from '../../../components/inputs/RadioGroup/RadioGroupComponent';
import MultiSelectComponent from '../../../components/inputs/Select/MultiSelectComponent';
import SelectComponent from '../../../components/inputs/Select/SelectComponent';
import TextFieldComponent from '../../../components/inputs/Textfield/TextfieldComponent';
import { useGetPaymentTypesQuery } from '../../../hooks/useGetPaymentTypesQuery';
import { useGetSchoolBankConfigQuery } from '../../../hooks/useGetSchoolBankConfigQuery';
import { routes } from '../../../routes';
import { createProcessModel } from '../../../services/finance/processModels';
import { ProcessModelType } from '../../../types/Finance';
import { CourseLevels, Modalities, ProcessModels } from '../../../utils/codes';

export const CreateProcessModel = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const navigate = useNavigate();
  const mutation = useMutation({ mutationFn: createProcessModel, mutationKey: 'createProcessModel' });

  const defaultValues: ProcessModelType = {
    status: true,
    idSchoolBankConfig: '',
    processName: '',
    level: 'Licenciatura',
    modality: '1',
  }
  const { control, handleSubmit, setValue, getValues, formState: { errors } } = useForm<ProcessModelType>({
    defaultValues,
    mode: 'onBlur',
    reValidateMode: 'onBlur',
    shouldUseNativeValidation: false,
  });
  const { data: schoolBankConfigsData, status: schoolBankConfigsStatus, isError: isErrorSchoolschoolBankConfigs, isLoading: isLoadingSchoolschoolBankConfigs } = useGetSchoolBankConfigQuery({ PageNumber: currentPage, PageSize: 400 });
  const { data: paymentTypesData, status: paymentTypesStatus, isError: isErrorPaymentTypes, isLoading: isLoadingPaymentTypes } = useGetPaymentTypesQuery({ PageNumber: 1, PageSize: 400 });

  const handleBack = () => {
    navigate(routes.processModels);
  }
  const onSubmit = handleSubmit(async (data) => {
    try {
      try {
        if (!data.idsPaymentTypes || data.idsPaymentTypes.length === 0) {
          throw new Error("Selecione pelo menos um Tipo de emolumento");
        }
        if (Array.isArray(data.idsPaymentTypes)) {
          data.idsPaymentTypes = data.idsPaymentTypes
            .map((id: string) => id.trim())
            .filter((id: string) => id !== '')
            .join(',');
        }
      } catch (ex) {
      }
      const result = await mutation.mutateAsync(data);
      if (result) {
        toast.success("Modelo criado");
        navigate(routes.processModels);
      }
    } catch (err: any) {
      toast.error(`${mutation.error ?? err?.message}`);
    }
  });

  return (
    <form onSubmit={onSubmit} noValidate>
      <Card size='1'>
        <Flex direction='column' gap='4'>

          <Flex gap="8">
            <SelectComponent
              name="processName"
              label="Nome do processo"
              control={control}
              errors={errors}
              style={{ width: '100%' }}
              options={ProcessModels?.map(u => ({
                value: u.id ?? "",
                label: u.description ?? ""
              }))}
              required={true}
            />
            {/* <TextFieldComponent name="processName" label="Nome do processo" control={control} errors={errors} fieldProps={{ placeholder: 'Nome do processo' }} style={{ width: '100%' }} required={true} /> */}
          </Flex>

          <Flex gap="8">
            <RadioGroupComponent name="level" label="Nivel" control={control} errors={errors} style={{ width: '100%' }}
              options={CourseLevels.map(cl => ({
                value: cl.id ?? "",
                label: cl.description ?? ""
              }))}
              fieldProps={{
                style: { display: 'flex', flexDirection: 'row', gap: '16px' }
              }}
            />
          </Flex>

          <Flex gap="8">
            <RadioGroupComponent name="modality" label="Modalidade" control={control} errors={errors} style={{ width: '100%' }}
              options={Modalities.map(m => ({
                value: m.id ?? "",
                label: m.description ?? ""
              }))}
              fieldProps={{
                style: { display: 'flex', flexDirection: 'row', gap: '16px' }
              }}
            />
          </Flex>

          <Flex gap="8">
            <TextFieldComponent name="description" label="Descrição" control={control} errors={errors} fieldProps={{ placeholder: 'Descrição' }} style={{ width: '100%' }} />
          </Flex>

          <SelectComponent
            name="idSchoolBankConfig"
            label="Entidade Bancária"
            control={control}
            errors={errors}
            itemsLoading={isLoadingSchoolschoolBankConfigs}
            itemsError={isErrorSchoolschoolBankConfigs}
            options={schoolBankConfigsData?.items?.map(item => ({
              value: item.id!,
              label: `${String(item.bankEntity!)} ${item?.bankName ?? ''} ${item?.bankDescription ?? ''}`,
            })) ?? []}
            style={{ width: '100%' }}
            required={true}
          />

          <Flex gap="6">
            <MultiSelectComponent
              name="idsPaymentTypes"
              label="Tipo(s) de pagamento"
              control={control}
              errors={errors}
              style={{ width: "100%" }}
              options={paymentTypesData?.items?.map(item => ({
                value: item.id!,
                label: String(item.description!) ?? "",
              })) ?? []}
              itemsError={isErrorPaymentTypes}
              itemsLoading={isLoadingPaymentTypes}
            />
          </Flex>

          <Flex direction='row' gap='4' style={{ alignSelf: 'end' }}>
            <Button color='red' onClick={handleBack} disabled={mutation.isLoading}>
              <ChevronLeftIcon /> voltar
            </Button>
            <Button type="submit" disabled={mutation.isLoading} variant='surface'>
              {mutation.isLoading ? <Spinner loading> <EnterIcon /></Spinner> : <EnterIcon />}
              Registar
            </Button>
          </Flex>
        </Flex>
      </Card>
    </form>
  )
}